__turbopack_context__.v({
  "hotDealCardBody": "_4NLYqW_hotDealCardBody",
});
